import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
} from "@material-ui/core";
import { TextField } from "@material-ui/core";

const styles = (theme) => ({});

function StudentCourseSettings(props) {
  const [iClicker, setiClicker] = React.useState(props.iClicker);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setiClicker(props.iClicker);
  }, [props.iClicker]);

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        props.openCtl(false);
      }}
    >
      <DialogTitle>Settings for {props.courseName}</DialogTitle>
      <DialogContent>
        <TextField
          label="iClicker"
          onChange={(event) => setiClicker(event.target.value)}
          value={iClicker}
        />
        <DialogActions>
          <Button onClick={() => props.openCtl(false)}>Cancel</Button>
          <Button
            onClick={() => {
              setLoading(true);

              props.editStudentCourseInfo(iClicker).then(() => {
                setLoading(false);
                props.openCtl(false);
              });
            }}
          >
            Save
          </Button>
        </DialogActions>
      </DialogContent>
      {loading && <LinearProgress />}
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(StudentCourseSettings))
  )
);
